import React, { useCallback, useEffect, useState } from 'react';
import { FormControl, InputLabel, MenuItem } from '@material-ui/core';
import { useSnackbar } from 'notistack';
import Select from '@material-ui/core/Select';

import { getProjectsByYear } from '../../../services/projectService';
import Loading from '../../common/loading';

const Project = ({ data: projectSlug, onProject, year }) => {
  const [projects, setProjects] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const populateProjects = useCallback(
    async (year) => {
      setIsLoading(true);
      try {
        const { data: projects } = await getProjectsByYear(year);
        setProjects(projects);
      } catch (ex) {
        if (ex.response && ex.response.status === 404)
          enqueueSnackbar(`${ex.response.data.message}`, { variant: 'error' });
      } finally {
        setIsLoading(false);
      }
    },
    [enqueueSnackbar]
  );

  const handleChange = ({ target: input }) => {
    const project = projects.find((project) => project.slug === input.value);
    onProject(project);
  };

  useEffect(() => {
    populateProjects(year);
  }, [year, populateProjects]);

  return (
    <>
      <Loading open={isLoading} />
      <FormControl variant='outlined' fullWidth size='small' margin='normal'>
        <InputLabel id='projectSlug'>Seleccione el proyecto *</InputLabel>
        <Select
          name='projectSlug'
          value={projectSlug}
          onChange={handleChange}
          labelWidth={180}
        >
          <MenuItem value='' disabled>
            <em>Seleccione una opción</em>
          </MenuItem>
          {projects.map((project) => (
            <MenuItem value={project.slug} key={project.slug}>
              {project.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </>
  );
};

export default Project;
